import HomeHero from "../components/HomeHero";
import HomeServices from "../components/HomeServices";
import HomeCategories from "../components/HomeCategories";
import HomeWhyChoose from "../components/HomeWhyChoose";
import HomeFinalCTA from "../components/HomeFinalCTA";
import TestimonialCarousel from "../components/TestimonialCarousel";
import Seo from "../components/Seo";

// Structure matches the new business-model mockup:
// Hero → Our Services → Featured Categories → Why Choose Us → Testimonials → Final CTA
const Home = () => (
  <div data-testid="page-home">
    <Seo
      title="Auto Spares & Vehicle Recovery — Middlesbrough, UK"
      description="Quality used & new auto parts, tyres, batteries, and 24/7 vehicle recovery services across the UK. Same-day supply, nationwide delivery."
      path="/"
    />
    <HomeHero />
    <HomeServices />
    <HomeCategories />
    <HomeWhyChoose />
    <TestimonialCarousel />
    <HomeFinalCTA />
  </div>
);

export default Home;
